import { Badge } from "@/components/ui/badge";

import {
  requisitionStatusToBackgroundColor,
  requisitionStatusToDotColor,
  requisitionStatusToLabel,
} from "@/lib/constants";
import { cn } from "@/lib/utils";
import { RequisitionStatus } from "@/types";

export const RequisitionStatusBadge = ({
  className,
  status,
}: {
  className?: string;
  status: RequisitionStatus;
}) => {
  return (
    <Badge
      variant="secondary"
      className={cn(
        "gap-2 font-normal",
        requisitionStatusToBackgroundColor[status],
        className,
      )}
    >
      <span
        className={cn("h-2 w-2 rounded-full", requisitionStatusToDotColor[status])}
      />
      {requisitionStatusToLabel[status]}
    </Badge>
  );
};
